import { Route, Routes } from "react-router-dom";
import { FC, useEffect } from "react";
import styles from "./App.module.scss";
import { Clubs, HomePageEN, Models } from "../../pages";
import { Header, Footer } from "../layout";
import { NotFound } from "../../pages/NotFound/NotFound";
import { Login } from "../../pages/Login/Login";
import { Register } from "../../pages/Register/Register";
import { Model } from "../../pages/Models/Model/Model";
import { ForgotPassword } from "../../pages/ForgotPassword/ForgotPassword";
import { ROUTES } from "../../helpers/routes";
import { ForgotPasswordCode } from "../../pages/ForgotPassword/ForgotPasswordCode/ForgotPasswordCode";
import { SetPassword } from "../../pages/ForgotPassword/SetPassword/SetPassword";
import { ModelPanel } from "../../pages/ModelPanel/ModelPanel";
import { fetchUser } from "../../services/slices/user";
import { useAppDispatch } from "../../services/hooks";
import { DataSecurity } from "../../pages/FooterPage/DataSecurity";
import { Agb } from "../../pages/FooterPage/Agb";
import { Abbreviation } from "../../pages/FooterPage/Abbreviation";
import { Impressum } from "../../pages/FooterPage/Impressum";
import ProtectedRoute from "../ProtectedRoute/ProtectedRoute";
import Cookies from "js-cookie";
import { AgeVerificationPopup } from "../ui/AgeVerificationPopup/AgeVerificationPopup";
import { Profile } from "../../pages/Profile/Profile";
import { AdminSettings } from "../../pages/AdminSettings/AdminSettings";
import { NotificationContainer } from "../Notification/NotificationContainer";

export const App: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (Cookies.get("accessToken")) dispatch(fetchUser());
  }, [dispatch]);

  return (
    <div className={styles.app}>
      <NotificationContainer />
      <AgeVerificationPopup />
      <Header />
      <div className={styles.container}>
        <Routes>
          <Route path={ROUTES.home} element={<HomePageEN />} />

          <Route path={ROUTES.clubs} element={<Clubs />} />
          <Route path={ROUTES.models} element={<Models />} />
          <Route
            path={`${ROUTES.modelPanel}/*`}
            element={
              <ProtectedRoute url={ROUTES.home}>
                <ModelPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${ROUTES.profile}/*`}
            element={
              <ProtectedRoute url={ROUTES.home}>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${ROUTES.admin}/*`}
            element={
              <ProtectedRoute url={ROUTES.home}>
                <AdminSettings />
              </ProtectedRoute>
            }
          />

          <Route path={ROUTES.login} element={<Login />} />
          <Route path={ROUTES.forgotPassword} element={<ForgotPassword />} />
          <Route
            path={`${ROUTES.forgotPassword}/code`}
            element={<ForgotPasswordCode />}
          />
          <Route path={ROUTES.setPassword} element={<SetPassword />} />
          <Route path={ROUTES.register} element={<Register />} />

          <Route path={ROUTES.dataSecurity} element={<DataSecurity />} />
          <Route path={ROUTES.agb} element={<Agb />} />
          <Route path={ROUTES.abbreviation} element={<Abbreviation />} />
          <Route path={ROUTES.impressum} element={<Impressum />} />

          <Route path={`${ROUTES.models}/:id`} element={<Model />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
};

export default App;
